import * as CSS from "csstype";
import { ReactElement } from "react";

import {
  Button,
  ButtonProps,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import theme from "theme";

const editButtonVariant = mobileStyleBreakpoint<
  // Prettier is fighting eslint, on this line.
  // prettier-ignore
  keyof (typeof theme.components.Button["variants"])
>("primary", "link");
const editButtonFrontWeight = mobileStyleBreakpoint<
  CSS.Property.FontWeight | undefined
>("bold", "normal");
const editButtonTextStyle = mobileStyleBreakpoint<string | undefined>(
  "cta",
  "body2"
);

const EditButton = ({ onClick, ...rest }: ButtonProps): ReactElement => {
  const buttonVariant = useBreakpointValue(editButtonVariant);
  return (
    <Button
      variant={buttonVariant as string}
      colorScheme="navy"
      w="100%"
      onClick={onClick}
      {...rest}
    >
      <Text
        textStyle={editButtonTextStyle}
        fontWeight={editButtonFrontWeight}
        color="inherit"
      >
        Edit
      </Text>
    </Button>
  );
};

export default EditButton;
